import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

export default function GenericAddModal({ isOpen, onClose, onAdd, fields, title }) {
  const [formData, setFormData] = useState({});

  if (!isOpen) return null;

  const handleChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd(formData);
    setFormData({});
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4">
      <div className="bg-white rounded-sm shadow-xl w-full max-w-md flex flex-col max-h-[90vh] border border-gray-400 font-sans">
        <div className="flex justify-between items-center p-3 border-b border-teal-300 bg-[#a6e4e7]">
          <h3 className="font-bold text-teal-900 text-[14px]">{title || 'Add New Record'}</h3>
          <FiX className="cursor-pointer text-teal-900 hover:text-red-600 text-lg" onClick={onClose} />
        </div>
        <div className="p-4 overflow-y-auto flex-1 bg-gray-50">
          <form id="add-form" onSubmit={handleSubmit} className="space-y-3">
            {fields.map((f) => (
              <div key={f.name}>
                <label className="block text-[12px] font-bold text-gray-700 mb-1">{f.label}</label>
                <input
                  type={f.type || 'text'}
                  className="w-full border border-gray-300 p-1.5 rounded-sm focus:outline-none focus:border-[#0000a0] text-[13px] shadow-inner bg-white"
                  onChange={(e) => handleChange(e, f.name)}
                  value={formData[f.name] || ''}
                  required={f.required !== false}
                  placeholder={`Enter ${f.label.toLowerCase()}`}
                />
              </div>
            ))}
          </form>
        </div>
        <div className="p-3 border-t border-gray-300 flex justify-end space-x-2 bg-gray-100">
          <button 
            type="button" 
            onClick={onClose} 
            className="px-4 py-1.5 bg-white border border-gray-300 text-gray-700 rounded-sm hover:bg-gray-50 text-[12px] font-bold shadow-sm"
          >
            CANCEL
          </button>
          <button 
            type="submit" 
            form="add-form" 
            className="px-4 py-1.5 bg-[#0000a0] text-white rounded-sm hover:bg-blue-900 text-[12px] font-bold shadow-sm"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
}